/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime: 2020-11-13 15:07:50
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\weixin\previewhistory\weixinPreviewHistoryRouter.js
 * @Description: 
 */
'use strict';
angular.module('weixinPreviewHistoryRouterModule', [])
    . config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('front.editctr.weixin.previewhistory', {
            url: '/previewhistory?wxchannelid',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/weixin/previewhistory/main_tpl.html',
                    controller: 'weixinPreviewHistoryCtrl'
                }
            }
        });
    }]);
